import comp from "./LearningCourseSelectionFeed";
export default comp;
